export default {"src":"/accounts/_next/static/media/RegisterComplete.f794d417.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};